// Module
var code = "<p>Это рынок бинарных прогнозов.</p> <p>Соотношение обеспечения для этого рынка составляет 1:1.</p> ";
// Exports
export default code;